import { observer } from 'mobx-react-lite';
import DigitalHumanStore from '@/stores/digital-human-store';

interface SubtitleOverlayProps {
  store: DigitalHumanStore;
}

export const SubtitleOverlay = observer(({ store }: SubtitleOverlayProps) => {
  if (!store.subtitleText) return null;

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-6 z-[85] flex justify-center px-12">
      <p className="max-w-3xl text-center text-lg font-medium leading-snug text-white/90 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
        {store.subtitleText}
      </p>
    </div>
  );
});
